import { RequestHelper } from "../lib";

class BaseService {
    private _apiUrl = "";

    constructor(apiUrl: string) {
        this._apiUrl = apiUrl;
    }

    protected _get<T>(path: string) {
        const helper = new RequestHelper(this._apiUrl).withPath(path);
        return helper.usingPromise().get<T>();
    }

    protected _post<T>(path: string, request: any) {
        const helper = new RequestHelper(this._apiUrl).withPath(path);
        return helper.usingPromise().post<T>(request);
    }
}

export default BaseService;